import styled from 'styled-components'
import { IconQuestion } from '../../../../iconography/Icons/Icons'

export const TableHeader = styled.div`
  color: ${props => props.theme.color.secondary300};
`

export const TableCell = styled.div`
  font-weight: bold;
`

export const ResultTable = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: center;
  text-align: center;
  column-gap: 46px;

  ${props => props.theme.media.mobile`
    width: auto;
  `}
`

export const MatchingProductsHeader = styled.div`
  margin-top: 40px;
  margin-bottom: 24px;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  text-transform: uppercase;
  text-align: center;
`

export const MatchingRecommendedTitle = styled.div<{ isActive?: boolean }>`
  color: ;
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
  margin-top: -10px;
  color: ${({ isActive }: { isActive?: boolean }) =>
    isActive ? props => props.theme.color.primary200 : props => props.theme.color.textTertiary};
`

export const MatchingCard = styled.div`
  padding: 8px;
  padding-top: 20px;
  color: ${props => props.theme.color.textPrimary};
  font-weight: 500;
  width: 186px;
  height: 104px;
  border-radius: 12px;
  background-color: ${props => props.theme.color.primary25};
  white-space: normal;
  text-align: center;
  cursor: pointer;
  word-break: break-word;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &:hover {
    background-color: ${props => props.theme.color.primary100};
  }

  ${props => props.theme.media.mobile`
    width: 124px;
    height: 80px;
  `}
`

export const MatchingCardChoosed = styled.div`
  padding: 8px;
  padding-top: 20px;
  color: ${props => props.theme.color.backgroundSecondary};
  font-weight: 500;
  width: 186px;
  height: 104px;
  border-radius: 12px;
  background-color: ${props => props.theme.color.outlinePrimary};
  white-space: normal;
  text-align: center;
  cursor: pointer;
  word-break: break-word;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${props => props.theme.media.mobile`
    width: 124px;
    height: 80px;
  `}
`

export const MatchingBody = styled.div`
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;

  ${props => props.theme.media.mobile`
    font-size: 14px;
    line-height: 18px;
  `}
`

export const MatchingCardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 186px);
  grid-gap: 17px;
  justify-content: center;

  ${props => props.theme.media.mobile`
    grid-template-columns: repeat(2, 124px);
    grid-gap: 8px;
  `}
`

export const CardWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  margin-bottom: 24px;
`

export const ShowMoreProductsContainer = styled.div`
  color: ${props => props.theme.color.outlinePrimary};
  display: flex;
  justify-content: center;
  margin: 24px 0;
  cursor: pointer;
`

export const ShowMoreProducts = styled.div`
  cursor: pointer;
`

export const StepResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const MoreProductsCardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 186px);
  grid-gap: 17px;
  justify-content: center;

  ${props => props.theme.media.mobile`
    grid-template-columns: repeat(2, 124px);
    grid-gap: 8px;
  `}
`

export const MoreProductsContainter = styled.div`
  padding: 40px 0 0;
`

export const Description = styled.div`
  width: 292px;
  bottom: 10px;
  left: -88px;
  position: absolute;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 0 40px rgb(0 0 0 / 16%);
  color: ${props => props.theme.color.textPrimary};
  font-size: 12px;
  line-height: 16px;
  padding: 16px;
  text-align: left;

  ${props => props.theme.media.mobile`
    width: 124px;
    left: -54px;
  `};
`

export const DescriptionIcon = styled.div`
  position: absolute;
  right: 2px;
  top: -14px;
`

export const StyledIconQuestion = styled(IconQuestion)`
  width: 16px;
  height: 16px;
`

export const UnitsOfMeasurement = styled.div<{ isActive?: boolean }>`
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: ${({ isActive }: { isActive?: boolean }) =>
    isActive ? props => props.theme.color.primary200 : props => props.theme.color.textTertiary};
  text-transform: none;
`

export const MatchingBodyFinalQty = styled.div`
  text-transform: none;
`
